<template>
  <div class="animated fadeIn">
    <div class="my-5">

      <div v-if="!valid">

        <div class="display-4 font-3xl text-center">
          <span>{{this.getValidationTitle}}</span>
        </div>
        <div class="mb-4"></div>
        <b-alert show v-for="(error, index) in errors" variant="danger" :key="index">{{error}}</b-alert>

      </div>

      <div v-else>
        <div class="display-4 font-3xl text-center">
          <span>{{this.getTitle}}</span>
        </div>
        <div v-if="submissions" class="mt-5">
          <div v-for="(submission, index) in submissions" :key="index" class="mb-3">
            <submission-card :submission="submission" :index="index" include_cost="true" @removeSubmission="$emit('removeSubmission', $event)"></submission-card>
          </div>
          <div class="clearfix mb-3">
            <div class="float-right h5">
              <span class="mr-2 text-muted">Subtotal:</span>
              <span>{{(this.total ? '$'+ parseFloat(this.total).toFixed(2) : 'TBD')}}</span>
            </div>
          </div>
          <div class="clearfix my-1">
            <b-button
              class="float-right"
              variant="success"
              size="lg"
              @click="addSubmissionsAndCheckout"
            >Pay</b-button>
            <b-button
              class="float-right mr-2"
              variant="success"
              size="lg"
              @click="addSubmissionsAndContinue"
            >I have more samples</b-button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import SubmissionCard from "../../components/submissions/SubmissionCard";

  export default {
    name: 'SubmissionAddStep4',
    components: {
      SubmissionCard,
    },
    props: ["submissions", "testPackage"],
    data() {
      return {
        collection: this.submissions || [],
        total: null,
        valid: false,
        errors: [],
      }
    },
    computed: {
      getValidationTitle() {
        return (this.submissions && this.submissions.length ? 'One of your submissions is invalid, correct the field below to continue:' : 'Once you fill your sample(s) you can review your submission.');
      },
      getTitle() {
        return (this.submissions && this.submissions.length ? 'Review your submission(s) below.' : 'Once you fill your sample(s) you can review your submission.');
      }
    },
    methods: {
      addSubmissionsAndCheckout() {
        this.$emit('addSubmissionsAndCheckout');
      },
      addSubmissionsAndContinue() {
        this.$emit('addSubmissionsAndContinue');
      }
    },
    watch: {
      collection: {
        handler() {
          this.total = 0;
          this.collection.forEach((submission) => {
            this.total = +(submission.getTotal(true));
          });
        },
        deep: true,
        immediate: true
      },
    },
    mounted() {
      this.valid = false;
      if(this.submissions && this.submissions.length) {
        this.errors = [];
        this.submissions.forEach((submission) => {
          let results = submission.validate();
          if(!results.status) {
            results.errors.forEach((err) => {
              this.errors.push(err);
            });
          }
        });
        if(!this.errors.length) {
          this.valid = true;
        }
      }
    }
  }
</script>
